export default __webpack_public_path__ + "static/subi-a83dd5beebcabc715c9e281925dd45a6.png";